// Version marker — bump this any time the behavior changes so we can verify
// which build is live via DevTools console.
const BUILD_MY_ROUTINE_VERSION = '2026-05-13-teen-brand-soft-v1';
console.log('[BuildMyRoutine] version:', BUILD_MY_ROUTINE_VERSION);
window.__bmrReady = window.__bmrReady || false;
window.__bmrRequestedOpen = window.__bmrRequestedOpen || false;

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-build-routine-open]');
  if (!trigger || window.__bmrReady) return;

  event.preventDefault();
  window.__bmrRequestedOpen = true;
});
async function initBuildMyRoutine() {
  const root = document.getElementById('build-my-routine-root');
  if (!root) return;

  root.dataset.bmrVersion = BUILD_MY_ROUTINE_VERSION;

  const openButtons = document.querySelectorAll('[data-build-routine-open]');
 
  const panel = root.querySelector('.build-my-routine-panel');

  const titleEl = document.getElementById('routine-title');
  const summaryEl = document.getElementById('routine-summary');
  const cardsEl = document.getElementById('routine-cards');
  const totalEl = document.getElementById('routine-total');
  const addToCartBtn = document.getElementById('build-my-routine-add-to-cart');
  const statusEl = document.getElementById('build-my-routine-status');
  const variationsBarEl = document.getElementById('routine-variations-bar');
  const shuffleBtnEl = document.getElementById('routine-shuffle-btn');
  const variationCountEl = document.getElementById('routine-variation-count');
  const noResultsEl = document.getElementById('routine-no-results');
  const noResultsTitleEl = document.getElementById('routine-no-results-title');
  const noResultsBodyEl = document.getElementById('routine-no-results-body');
  const noResultsClearBrandsBtn = document.getElementById('routine-no-results-clear-brands');

  const fitzpatrickEl = document.getElementById('build-my-routine-fitzpatrick');
  const productsDataScript = document.getElementById('build-my-routine-products-data');

  const concernOptionsEl = document.getElementById('build-my-routine-concern-options');
  const skinProfileOptionsEl = document.getElementById('build-my-routine-skin-profile-options');
  const skinSensitivityOptionsEl = document.getElementById('build-my-routine-skin-sensitivity-options');
  const routinePreferenceOptionsEl = document.getElementById('build-my-routine-routine-preference-options');
  const brandOptionsEl = document.getElementById('build-my-routine-brand-options');
  const currentActivesOptionsEl = document.getElementById('build-my-routine-current-actives-options');
  const treatmentsOptionsEl = document.getElementById('build-my-routine-treatment-options');
  const treatmentNoteEl = document.getElementById('build-my-routine-treatment-note');
  const retinolWarningEl = document.getElementById('routine-retinol-warning');
  const allergyOptionsEl = document.getElementById('build-my-routine-allergy-options');

  const disclaimerRoot = document.getElementById('build-my-routine-disclaimer');

const disclaimerCancelBtn = document.getElementById('build-my-routine-disclaimer-cancel');
const disclaimerConfirmBtn = document.getElementById('build-my-routine-disclaimer-confirm');

  const products = await parseProducts(productsDataScript);
  const optionSets = buildOptionSets(products);

const TREATMENT_OPTIONS = [
  { value: 'injectables_warning_only', label: 'Botox / fillers' },
  { value: normalizeValue('Chemical peels'), label: 'Chemical peels' },
  { value: normalizeValue('Laser / IPL'), label: 'Laser / IPL' },
  { value: normalizeValue('Microneedling'), label: 'Microneedling' }
];
const TREATMENT_FILTER_VALUES = TREATMENT_OPTIONS
  .filter((option) => option.value !== 'injectables_warning_only')
  .map((option) => option.value);

  let currentRoutineItems = [];
  let currentRecommendations = [];

  let slotOffsets = {};
  let routineVariationIndex = 0;
  const currentSlotCandidates = {};
  let routineDistinctIndices = [0];
  let currentVariationPosition = 0;

  // Slot keys the user has explicitly removed from their routine via
  // the "×" button on a card. Persists to localStorage along with the
  // rest of the user's selections. Stays removed across filter changes
  // and across sessions until the user clicks "Restore removed steps".
  let removedSlots = new Set();

  const cardNodes = new Map();
  let makeupEmptyNoticeEl = null;
  let disclaimerAccepted = false;
  const restoreRemovedBtn = document.getElementById('routine-restore-removed');

   function candidatesForSlot(slot, { strict }) {
    return candidatesForSlotFromProducts(slot, { strict, products });
  }

  function hasClearHydrationSplit() {
    if (state.routine_preference !== 'am_plus_pm') return false;

    const amHydrationCandidates = candidatesForSlot('moisturiser', { strict: true })
  .filter((product) =>
    product.routine_preference === 'am_only' ||
    product.routine_preference === 'am_plus_pm'
  );

    const pmHydrationCandidates = candidatesForSlot('night_cream', { strict: true })
      .filter((product) => product.routine_preference === 'pm_only');

    return amHydrationCandidates.length > 0 && pmHydrationCandidates.length > 0;
  }

  function buildCurrentPlanWithHydrationSplit() {
    const hasSplit = hasClearHydrationSplit();

    return buildCurrentPlan()
      .filter((step) => {
        if (state.routine_preference !== 'am_plus_pm') return true;
        if (step.slot !== 'night_cream') return true;
        return hasSplit;
      })
      .map((step) => {
        if (step.slot === 'moisturiser') {
          return {
            ...step,
            step: hasSplit ? 'AM Hydration' : 'Hydration',
            label: 'Hydration'
          };
        }

        if (step.slot === 'night_cream') {
          return {
            ...step,
            step: hasSplit ? 'PM Hydration' : 'Hydration',
            label: 'Hydration'
          };
        }

        return step;
      });
  }
  function candidatesForSlotWithHydrationPreference(slot, options) {
    let candidates = candidatesForSlot(slot, options);

    if (state.routine_preference !== 'am_plus_pm') {
      return candidates;
    }

    const hasSplit = hasClearHydrationSplit();

if (slot === 'moisturiser') {
  const preferredHydration = candidates.filter((candidate) =>
    hasSplit
      ? candidate.routine_preference === 'am_only' || candidate.routine_preference === 'am_plus_pm'
      : candidate.routine_preference === 'am_plus_pm'
  );

  if (preferredHydration.length) {
    candidates = preferredHydration;
  }
}

    if (slot === 'night_cream' && hasSplit) {
      const pmHydration = candidates.filter((candidate) =>
        candidate.routine_preference === 'pm_only'
      );

      if (pmHydration.length) {
        candidates = pmHydration;
      }
    }

    return candidates;
  }
  function resetVariations() {
    slotOffsets = {};
    routineVariationIndex = 0;
    currentVariationPosition = 0;
    routineDistinctIndices = [0];
  }

  function pickBestForSlot(slot, excludeHandles) {
        let candidates = candidatesForSlotWithHydrationPreference(slot, { strict: true });
    if (!candidates.length) {
      candidates = candidatesForSlotWithHydrationPreference(slot, { strict: false });
    }

    currentSlotCandidates[slot] = candidates;

    let pickPool = candidates;

    if (excludeHandles && excludeHandles.size) {
      const filtered = candidates.filter((candidate) => !excludeHandles.has(candidate.handle));
      if (filtered.length) pickPool = filtered;
    }

    if (!pickPool.length) return null;

    const rawOffset = slotOffsets[slot] !== undefined
      ? slotOffsets[slot]
      : routineVariationIndex;

    const offset = ((rawOffset % pickPool.length) + pickPool.length) % pickPool.length;
    return pickPool[offset];
  }

 function getRecommendedProducts() {
  const plan = buildCurrentPlanWithHydrationSplit()
    .filter((step) => !removedSlots.has(step.slot));

  const picks = {};

  Object.keys(currentSlotCandidates).forEach((key) => delete currentSlotCandidates[key]);

  const usedHandles = new Set();

  for (const step of plan) {
    const product = pickBestForSlot(step.slot, usedHandles);

    if (product) {
      picks[step.slot] = product;
      usedHandles.add(product.handle);
    }
  }

  const lockedSlots = new Set(Object.keys(slotOffsets));

  applyBrandClustering(plan, picks, lockedSlots, candidatesForSlotWithHydrationPreference);

  // Budget is intentionally NOT used as a hard filter here.
  // It only affects candidate ordering inside candidatesForSlotFromProducts().
  diversifyForVariation(
    plan,
    picks,
    null,
    lockedSlots,
    routineVariationIndex,
    currentSlotCandidates
  );

  return plan
    .map((step) => ({ ...step, product: picks[step.slot] || null }))
    .filter((item) => item.product);
}
  function selectRoutineFamilyOption(slotKey, handle) {
  const currentItem = currentRoutineItems.find((item) => item.slot === slotKey);
  const currentProduct = currentItem && currentItem.product;

  if (!currentProduct || !currentProduct.routine_family_id) return;

const familyOptions = getRoutineFamilySiblings(currentProduct, products);

const replacement = familyOptions.find((product) => product.handle === handle);

  if (!replacement) return;

  currentRoutineItems = currentRoutineItems.map((item) => {
    if (item.slot !== slotKey) return item;
    return { ...item, product: replacement };
  });

  renderCurrentRoutineState({ updateVariations: true });
}
  function applyPaediatricMode(isPaediatric) {
    applyPaediatricModeUi(isPaediatric, panel, root, renderConditionalGroups);
  }

  function renderConditionalGroups() {
    const isPaediatric = state.age === '0-12';

    const paediatricAgeLabel = AGE_BUTTON_TO_LABEL['0-12'];

const paediatricBrandSlugs = new Set(
  products
    .filter((product) =>
      product.available &&
      product.age_category_labels &&
      product.age_category_labels.includes(paediatricAgeLabel)
    )
    .map((product) => product.vendor_slug)
    .filter(Boolean)
);

const brandOptions = isPaediatric
  ? optionSets.brands.filter((option) => paediatricBrandSlugs.has(option.value))
  : optionSets.brands;
    renderMultiOptions(
      brandOptionsEl,
      'preferred_brands',
      brandOptions,
      true,
      updateRecommendations
    );

 const allergyOptions = optionSets.allergies;

    renderMultiOptions(
      allergyOptionsEl,
      'allergies',
      allergyOptions,
      false,
      updateRecommendations
    );

    const skinProfileOptions = isPaediatric
      ? optionSets.skin_profile.filter((option) => PAEDIATRIC_SKIN_PROFILE_LABELS.has(option.label))
      : optionSets.skin_profile;

    const skinProfileDefault = isPaediatric ? 'Normal' : DEFAULTS.skin_profile;

    renderSingleOptions(
      skinProfileOptionsEl,
      'skin_profile',
      skinProfileOptions,
      skinProfileDefault,
      updateRecommendations,
      root
    );
  }

  function initializeDynamicGroups() {
    renderSingleOptions(
      concernOptionsEl,
      'concern',
      optionSets.concern,
      DEFAULTS.concern,
      updateRecommendations,
      root
    );

    renderSingleOptions(
      skinSensitivityOptionsEl,
      'skin_sensitivity',
      optionSets.skin_sensitivity,
      DEFAULTS.skin_sensitivity,
      updateRecommendations,
      root
    );

    renderSingleOptions(
      routinePreferenceOptionsEl,
      'routine_preference',
      optionSets.routine_preference,
      DEFAULTS.routine_preference,
      updateRecommendations,
      root
    );

    renderConditionalGroups();

    renderMultiOptions(
      currentActivesOptionsEl,
      'current_actives',
      optionSets.current_actives,
      false,
      updateRecommendations
    );

   renderMultiOptions(
  treatmentsOptionsEl,
  'treatments',
  TREATMENT_OPTIONS,
  false,
  updateRecommendations
);
  }

    function initializeStaticGroups() {
    root.querySelectorAll('[data-group]').forEach((groupEl) => {
      const key = groupEl.dataset.group;
      const buttons = groupEl.querySelectorAll('button');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.dataset.value;
          if (!value) return;

          const previousValue = state[key];

          buttons.forEach((btn) => btn.classList.remove('is-active'));
          button.classList.add('is-active');

          state[key] = value;

         
 if (key === 'age') {
  const wasPaediatric = previousValue === '0-12';
  const isPaediatric = value === '0-12';
applyPaediatricMode(isPaediatric);

  if (wasPaediatric && !isPaediatric) {
    if (!state.concern) state.concern = normalizeValue(DEFAULTS.concern);
    if (!state.routine_preference) state.routine_preference = normalizeValue(DEFAULTS.routine_preference);
    if (!state.skin_sensitivity) state.skin_sensitivity = normalizeValue(DEFAULTS.skin_sensitivity);
    syncUIFromState();
  }

  updateRecommendations();
  return;
}

         if (key === 'budget') {
  updateRecommendations();
  return;
}

          updateRecommendations();
        });
      });
    });
  }
  function openDrawer() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('build-my-routine-lock');
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('build-my-routine-lock');
    closeDisclaimer();
  }
  document.addEventListener('click', (event) => {
  const openDropdowns = root.querySelectorAll('.build-my-routine-multi-dropdown[open]');
  if (!openDropdowns.length) return;

  const clickedDropdown = event.target.closest('.build-my-routine-multi-dropdown');

  openDropdowns.forEach((dropdown) => {
    if (dropdown !== clickedDropdown) {
      dropdown.removeAttribute('open');
    }
  });
});

  function openDisclaimer() {
    if (!disclaimerRoot) return;
    disclaimerRoot.classList.add('is-open');
    disclaimerRoot.setAttribute('aria-hidden', 'false');
  }

  function closeDisclaimer() {
    if (!disclaimerRoot) return;
    disclaimerRoot.classList.remove('is-open');
    disclaimerRoot.setAttribute('aria-hidden', 'true');
  }

  function renderEmptyState() {
    cardsEl.innerHTML = '';
    cardNodes.clear();
    makeupEmptyNoticeEl = null;
    totalEl.textContent = '';
  }

  function shouldShowMakeupEmptyNotice(plan, routineItems) {
    if (state.include_makeup !== 'yes') return false;

    const makeupSlots = plan.filter((step) => String(step.slot || '').startsWith('makeup'));
    if (!makeupSlots.length) return false;

    const hasMakeupPick = routineItems.some((item) => String(item.slot || '').startsWith('makeup'));
    return !hasMakeupPick;
  }

  function ensureMakeupEmptyNotice(plan, routineItems) {
    if (!shouldShowMakeupEmptyNotice(plan, routineItems)) {
      if (makeupEmptyNoticeEl && makeupEmptyNoticeEl.parentNode) {
        makeupEmptyNoticeEl.parentNode.removeChild(makeupEmptyNoticeEl);
      }

      makeupEmptyNoticeEl = null;
      return;
    }

    if (!makeupEmptyNoticeEl) {
      const built = buildMakeupEmptyNotice(clearBrandFilter);
      makeupEmptyNoticeEl = built.notice;
      makeupEmptyNoticeEl._parts = built;
    }

    updateMakeupEmptyNoticeCopy(makeupEmptyNoticeEl._parts, products, optionSets);
    cardsEl.appendChild(makeupEmptyNoticeEl);
  }
  function getRoutineCardSlotLabel(item) {
    const productType = cleanLabel(item.product && item.product.product_type_meta);

    return productType || item.label || '';
  }
  function renderCards(routineItems) {
    if (!routineItems.length) {
      renderEmptyState();
      return;
    }

    if (
      !cardNodes.size &&
      cardsEl.firstElementChild &&
      !cardsEl.firstElementChild.classList.contains('build-my-routine-card') &&
      !cardsEl.firstElementChild.classList.contains('build-my-routine-makeup-empty')
    ) {
      cardsEl.innerHTML = '';
      makeupEmptyNoticeEl = null;
    }

    const incomingHandles = new Set(routineItems.map((item) => item.product.handle));

    for (const [handle, node] of cardNodes) {
      if (!incomingHandles.has(handle)) {
        node.remove();
        cardNodes.delete(handle);
      }
    }

    let previousNode = null;

    routineItems.forEach((item) => {
            const { product, step, label, slot } = item;
      const displayLabel = getRoutineCardSlotLabel(item);

      let node = cardNodes.get(product.handle);

      if (!node) {
        node = buildRoutineCardNode({
          product,
          stepName: step,
          slotLabel: displayLabel,
          slotKey: slot,
          products,
          onSwapSlot: swapSlot,
          onSwapSlotBack: swapSlotBack,
          onRemoveSlot: removeSlot,
          onSelectFamilyOption: selectRoutineFamilyOption
        });

        cardNodes.set(product.handle, node);
      } else {
        updateRoutineCardStep(node, step, displayLabel);
        node.dataset.slot = slot || '';
      }

      const slotName = String(displayLabel || label || 'product').toLowerCase();
      const altCount = (currentSlotCandidates[slot] || []).length;
      const hasAlts = altCount >= 2;

      // Forward swap button (default modifier-less swap)
      const swapBtn = node.querySelector('.build-my-routine-card__swap:not(.build-my-routine-card__swap--back):not(.build-my-routine-card__swap--remove)');
      if (swapBtn) {
        swapBtn.setAttribute('aria-disabled', hasAlts ? 'false' : 'true');
        swapBtn.classList.toggle('is-disabled', !hasAlts);

        const tooltipText = hasAlts
          ? `Show a similar ${slotName} for this step (${altCount - 1} option${altCount - 1 === 1 ? '' : 's'} available)`
          : `No similar ${slotName} available for this step.`;

        const tooltip = swapBtn.querySelector('.build-my-routine-card__swap-tooltip');
        if (tooltip) tooltip.textContent = tooltipText;
      }

      // Back swap button — disabled if there are no alternatives at all,
      // since "back" only makes sense when forward swaps exist.
      const backBtn = node.querySelector('.build-my-routine-card__swap--back');
      if (backBtn) {
        backBtn.setAttribute('aria-disabled', hasAlts ? 'false' : 'true');
        backBtn.classList.toggle('is-disabled', !hasAlts);

        const backTooltipText = hasAlts
          ? `Go back to the previous ${slotName} for this step`
          : `No other ${slotName} available to go back to.`;

        const backTooltip = backBtn.querySelector('.build-my-routine-card__swap-tooltip');
        if (backTooltip) backTooltip.textContent = backTooltipText;
      }

      // Remove button — always enabled. Tooltip is informational only.
      const removeBtn = node.querySelector('.build-my-routine-card__swap--remove');
      if (removeBtn) {
        removeBtn.setAttribute('aria-disabled', 'false');
        removeBtn.classList.remove('is-disabled');

        const removeTooltip = removeBtn.querySelector('.build-my-routine-card__swap-tooltip');
        if (removeTooltip) {
          removeTooltip.textContent = `Remove the ${slotName} step from my routine`;
        }
      }

      if (previousNode) {
        previousNode.after(node);
      } else {
        cardsEl.prepend(node);
      }

      previousNode = node;
    });

    const total = routineItems.reduce((sum, item) => sum + item.product.price_cents, 0);
    totalEl.textContent = `Estimated total: ${formatMoney(total)}`;

        ensureMakeupEmptyNotice(buildCurrentPlanWithHydrationSplit(), routineItems);
  }

  function renderNoResults(noResults) {
    if (!noResultsEl) return;

    noResultsEl.hidden = !noResults;
    if (!noResults) return;

    const hasBrandFilter = Array.isArray(state.preferred_brands) && state.preferred_brands.length > 0 && !state.preferred_brands.includes('any');
    const brandLabels = hasBrandFilter ? brandLabelsForSlugs(state.preferred_brands, optionSets) : [];
    const brandList = formatBrandList(brandLabels);

    if (hasBrandFilter && brandList) {
      if (noResultsTitleEl) {
        noResultsTitleEl.textContent = '';
        noResultsTitleEl.hidden = true;
      }

      if (noResultsBodyEl) {
        noResultsBodyEl.textContent =
          'We couldn’t build a routine with your current selections. Try adjusting your filters, or chat to us on WhatsApp for a hand-picked routine.';
      }

      if (noResultsClearBrandsBtn) noResultsClearBrandsBtn.hidden = false;
      return;
    }

    if (noResultsTitleEl) {
      noResultsTitleEl.textContent = 'No products match these filters';
      noResultsTitleEl.hidden = false;
    }

    if (noResultsBodyEl) {
      noResultsBodyEl.textContent =
        'Try adjusting your selections — for example, change your skin profile or sensitivity, widen your budget, or remove an allergy. You can also chat to us on WhatsApp for a hand-picked routine.';
    }

    if (noResultsClearBrandsBtn) noResultsClearBrandsBtn.hidden = true;
  }

  function clearBrandFilter() {
    state.preferred_brands = ['any'];

    if (brandOptionsEl) {
      brandOptionsEl.querySelectorAll('button').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.value === 'any');
      });
    }

    updateRecommendations();
  }

  function renderRetinolWarning(routineItems) {
    if (!retinolWarningEl) return;

    if (typeof containsRetinolProduct === 'function') {
      retinolWarningEl.hidden = !containsRetinolProduct(routineItems);
      return;
    }

    retinolWarningEl.hidden = true;
  }

  function computeDistinctVariations() {
        const plan = buildCurrentPlanWithHydrationSplit();
    const maxCandidateCount = Math.max(
      1,
      ...plan.map((step) => (currentSlotCandidates[step.slot] || []).length || 1)
    );

    const maxToCheck = Math.min(maxCandidateCount, 12);
    const seen = new Set();
    const distinct = [];

    const savedIndex = routineVariationIndex;
    const savedOffsets = slotOffsets;
    const savedCache = { ...currentSlotCandidates };

    try {
      slotOffsets = {};

      for (let index = 0; index < maxToCheck; index += 1) {
        routineVariationIndex = index;

        const items = getRecommendedProducts();
        const signature = items
          .map((item) => `${item.slot}:${item.product.handle}`)
          .join('|');

        if (!seen.has(signature)) {
          seen.add(signature);
          distinct.push(index);
        }
      }
    } finally {
      routineVariationIndex = savedIndex;
      slotOffsets = savedOffsets;

      Object.keys(currentSlotCandidates).forEach((key) => delete currentSlotCandidates[key]);
      Object.assign(currentSlotCandidates, savedCache);
    }

    routineDistinctIndices = distinct.length ? distinct : [0];

    const activeIndex = routineDistinctIndices.indexOf(routineVariationIndex);
    currentVariationPosition = activeIndex >= 0
      ? activeIndex
      : ((currentVariationPosition % routineDistinctIndices.length) + routineDistinctIndices.length) % routineDistinctIndices.length;

    return routineDistinctIndices.length;
  }

      function renderVariationsBar() {
    if (!variationsBarEl || !shuffleBtnEl || !variationCountEl) return;
    const shuffleLabelEl = shuffleBtnEl.querySelector('.build-my-routine-shuffle__label');
const shuffleTooltipEl = shuffleBtnEl.querySelector('.build-my-routine-shuffle__tooltip');

function setShuffleButtonCopy(label, tooltip) {
  if (shuffleLabelEl) {
    shuffleLabelEl.textContent = label;
  } else {
    shuffleBtnEl.textContent = label;
  }

  if (shuffleTooltipEl) {
    shuffleTooltipEl.textContent = tooltip || '';
  }
}

    const hasNoRoutine = currentRoutineItems.length === 0;

    variationsBarEl.hidden = false;
    shuffleBtnEl.disabled = false;
    shuffleBtnEl.setAttribute('aria-disabled', hasNoRoutine ? 'true' : 'false');
    shuffleBtnEl.classList.toggle('is-disabled', hasNoRoutine);

    if (hasNoRoutine) {
      setShuffleButtonCopy(
  'No routine match',
  'No routine can be built from the current selections.'
);
      variationCountEl.textContent = '';
      return;
    }

    const hasSlotAlternatives = currentRoutineItems.some((item) => {
      const candidates = currentSlotCandidates[item.slot] || [];
      return candidates.length >= 2;
    });

    const count = computeDistinctVariations();
    const hasMultipleRoutines = count > 1;

       const canShuffle = hasMultipleRoutines || hasSlotAlternatives;

    shuffleBtnEl.disabled = false;
    shuffleBtnEl.setAttribute('aria-disabled', canShuffle ? 'false' : 'true');
    shuffleBtnEl.classList.toggle('is-disabled', !canShuffle);

    setShuffleButtonCopy(
  canShuffle ? 'Show another routine' : 'Best current routine',
  canShuffle
    ? 'Show another routine that still matches your selections.'
    : 'No other routine options match your current filters.'
);

        const visibleVariationCount = hasMultipleRoutines
      ? count
      : hasSlotAlternatives
        ? Math.max(
            1,
            ...currentRoutineItems.map((item) =>
              (currentSlotCandidates[item.slot] || []).length || 1
            )
          )
        : 1;

    let visibleVariationPosition = 0;

    if (hasMultipleRoutines) {
      visibleVariationPosition = currentVariationPosition;
    } else if (hasSlotAlternatives) {
      const offsets = currentRoutineItems
        .map((item) => {
          const value = slotOffsets[item.slot];
          return Number.isFinite(value) ? value : routineVariationIndex;
        })
        .filter(Number.isFinite);

      const rawPosition = offsets.length
        ? Math.max(...offsets)
        : routineVariationIndex;

      visibleVariationPosition =
        ((rawPosition % visibleVariationCount) + visibleVariationCount) % visibleVariationCount;
    }

    variationCountEl.textContent = hasMultipleRoutines || hasSlotAlternatives
      ? `Routine ${visibleVariationPosition + 1} of ${visibleVariationCount}`
      : '';
  }

  function preserveRoutineFamilyChoices(previousItems, nextItems) {
    if (!previousItems.length || !nextItems.length) return nextItems;

    const previousBySlot = new Map(
      previousItems.map((item) => [item.slot, item.product])
    );

    return nextItems.map((item) => {
      const previousProduct = previousBySlot.get(item.slot);

      if (!previousProduct || !previousProduct.routine_family_id) {
        return item;
      }

      if (
        item.product &&
        item.product.routine_family_id === previousProduct.routine_family_id
      ) {
        return item;
      }

      const candidates = currentSlotCandidates[item.slot] || [];

      const sameFamilyCandidate = candidates.find((candidate) =>
        candidate &&
        candidate.routine_family_id &&
        candidate.routine_family_id === previousProduct.routine_family_id &&
        candidate.slot === item.slot
      );

      if (!sameFamilyCandidate) return item;

      const usedElsewhere = nextItems.some((otherItem) =>
        otherItem.slot !== item.slot &&
        otherItem.product &&
        otherItem.product.handle === sameFamilyCandidate.handle
      );

      if (usedElsewhere) return item;

      return {
        ...item,
        product: sameFamilyCandidate
      };
    });
  }

    function renderCurrentRoutineState({ updateVariations = true } = {}) {
    currentRecommendations = currentRoutineItems.map((item) => item.product);

    const plan = buildCurrentPlanWithHydrationSplit()
      .filter((step) => !removedSlots.has(step.slot));

    const noResults = currentRoutineItems.length === 0;
    const fullRoutine = currentRoutineItems.length === plan.length;

    if (addToCartBtn) {
      addToCartBtn.disabled = noResults;
      addToCartBtn.classList.toggle('is-disabled', noResults);
      addToCartBtn.textContent = noResults ? 'No routine to add' : 'Add Routine to Cart';
    }

    if (titleEl) {
      if (noResults) {
        titleEl.textContent = 'No matching routine';
      } else {
        titleEl.textContent = fullRoutine ? 'Your routine' : 'Closest matching routine';
      }
    }

    if (summaryEl) {
      summaryEl.textContent = buildRoutineSummary(currentRoutineItems, optionSets);
    }

    if (updateVariations) {
      renderVariationsBar();
    }

    renderNoResults(noResults);
    renderCards(currentRoutineItems);
    renderRetinolWarning(currentRoutineItems);
    updateRestoreButtonVisibility();
    persistState();
  }
  function renderTreatmentNote() {
  if (!treatmentNoteEl) return;

  const selectedTreatments = state.treatments || [];
  const notes = [];

  if (selectedTreatments.includes('injectables_warning_only')) {
    notes.push(
      'Botox/fillers: most skincare does not need to be avoided, but for the first 24–48 hours avoid rubbing, massaging, exfoliating, or applying strong actives directly over treated areas. If the area is tender, keep skincare simple.'
    );
  }

  if (
    selectedTreatments.some((treatment) =>
TREATMENT_FILTER_VALUES.includes(treatment)
    )
  ) {
    notes.push(
  'For regular peels, laser/IPL or microneedling, we’ll avoid stronger actives and prioritise gentle cleanser, hydration, barrier repair and SPF. For a once-off treatment, follow your practitioner’s short-term aftercare advice.'
);
  }

  treatmentNoteEl.hidden = notes.length === 0;
  treatmentNoteEl.innerHTML = notes.map((note) => `<p>${note}</p>`).join('');
}
    function updateRecommendations({ keepVariations = false } = {}) {
    renderTreatmentNote();

    const previousRoutineItems = currentRoutineItems;

    if (!keepVariations) resetVariations();

    currentRoutineItems = getRecommendedProducts();

    if (!keepVariations) {
      currentRoutineItems = preserveRoutineFamilyChoices(previousRoutineItems, currentRoutineItems);
    }

    renderCurrentRoutineState({ updateVariations: true });
  }

function shuffleRoutine() {
  const swappableSlots = currentRoutineItems
    .map((item) => item.slot)
    .filter((slot) => (currentSlotCandidates[slot] || []).length >= 2);

  if (!swappableSlots.length && routineDistinctIndices.length < 2) return;

  if (routineDistinctIndices.length >= 2) {
    currentVariationPosition = (currentVariationPosition + 1) % routineDistinctIndices.length;
    routineVariationIndex = routineDistinctIndices[currentVariationPosition];
  } else {
    routineVariationIndex += 1;
    currentVariationPosition += 1;
  }

  swappableSlots.forEach((slot) => {
    const candidates = currentSlotCandidates[slot] || [];
    const currentItem = currentRoutineItems.find((item) => item.slot === slot);
    const currentHandle = currentItem && currentItem.product && currentItem.product.handle;

    const currentIndex = candidates.findIndex((candidate) => candidate.handle === currentHandle);
    const baseIndex = currentIndex >= 0
      ? currentIndex
      : (slotOffsets[slot] !== undefined ? slotOffsets[slot] : routineVariationIndex);

    slotOffsets[slot] = baseIndex + 1;
  });

  updateRecommendations({ keepVariations: true });
}

  function swapSlotProduct(slotKey, direction) {
  const candidates = currentSlotCandidates[slotKey] || [];
  if (candidates.length < 2) return;

  const currentItem = currentRoutineItems.find((item) => item.slot === slotKey);
  if (!currentItem || !currentItem.product) return;

  const usedByOtherSlots = new Set(
    currentRoutineItems
      .filter((item) => item.slot !== slotKey && item.product)
      .map((item) => item.product.handle)
  );

  const pickPool = candidates.filter((candidate) =>
    candidate.handle === currentItem.product.handle ||
    !usedByOtherSlots.has(candidate.handle)
  );

  if (pickPool.length < 2) return;

  const currentIndex = pickPool.findIndex((candidate) =>
    candidate.handle === currentItem.product.handle
  );

  const safeCurrentIndex = currentIndex >= 0 ? currentIndex : 0;
  const nextIndex = (safeCurrentIndex + direction + pickPool.length) % pickPool.length;
  const nextProduct = pickPool[nextIndex];

  const candidateIndex = candidates.findIndex((candidate) =>
    candidate.handle === nextProduct.handle
  );

  slotOffsets[slotKey] = candidateIndex >= 0 ? candidateIndex : nextIndex;

  currentRoutineItems = currentRoutineItems.map((item) => {
    if (item.slot !== slotKey) return item;
    return { ...item, product: nextProduct };
  });

  renderCurrentRoutineState({ updateVariations: true });
}

function swapSlot(slotKey) {
  swapSlotProduct(slotKey, 1);
}

function swapSlotBack(slotKey) {
  swapSlotProduct(slotKey, -1);
}  
  // Mark a slot key as removed and re-render. updateRecommendations() will
  // filter the slot out of the plan, the card will disappear, and the
  // headline count + total will update automatically. Persistence happens
  // inside updateRecommendations.
  function removeSlot(slotKey) {
    if (!slotKey) return;
    if (removedSlots.has(slotKey)) return;
    removedSlots.add(slotKey);
    updateRecommendations({ keepVariations: true });
  }

  // Wipe the removed-slots set so every step the user previously removed
  // comes back. Used by the "Restore removed steps" button.
  function restoreRemovedSlots() {
    if (!removedSlots.size) return;
    removedSlots = new Set();
    updateRecommendations();
  }

  function updateRestoreButtonVisibility() {
    if (!restoreRemovedBtn) return;
    const hasRemoved = removedSlots.size > 0;
    restoreRemovedBtn.hidden = !hasRemoved;
    if (hasRemoved) {
      const labelEl = restoreRemovedBtn.querySelector('.build-my-routine-restore-removed__label');
      if (labelEl) {
        labelEl.textContent = removedSlots.size === 1
          ? 'Restore 1 removed step'
          : `Restore ${removedSlots.size} removed steps`;
      }
    }
  }

  if (restoreRemovedBtn) {
    restoreRemovedBtn.addEventListener('click', (event) => {
      event.preventDefault();
      restoreRemovedSlots();
    });
  }

  // ---- Persistence ----------------------------------------------------
  // State persists per browser, keyed by Shopify customer id when the
  // visitor is logged in (so multiple shoppers on a shared device don't
  // collide), or under "anon" when logged out. Storage uses localStorage,
  // which behaves like a long-lived cookie for this kind of UI state.
  const STORAGE_KEY_PREFIX = 'bmr.state.';
  const STATE_KEYS_TO_PERSIST = [
    'concern',
    'skin_profile',
    'skin_sensitivity',
    'routine_preference',
    'budget',
    'age',
    'fitzpatrick',
    'preferred_brands',
    'current_actives',
    'topical_steroid_use',
    'recent_isotretinoin',
    'include_makeup',
    'allergies',
    'treatments'
  ];

  function getStorageKey() {
    const customerId = (root.dataset.customerId || '').trim();
    return STORAGE_KEY_PREFIX + (customerId || 'anon');
  }

  function loadPersistedState() {
    try {
      const raw = localStorage.getItem(getStorageKey());
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function persistState() {
    try {
      const stateSubset = {};
      STATE_KEYS_TO_PERSIST.forEach((key) => {
        if (state[key] !== undefined) stateSubset[key] = state[key];
      });
      const payload = {
        v: 1,
        state: stateSubset,
        removedSlots: Array.from(removedSlots)
      };
      localStorage.setItem(getStorageKey(), JSON.stringify(payload));
    } catch (e) {
      // localStorage may be disabled (private mode, full quota). Fail silently.
    }
  }

  function syncUIFromState() {
    // Single-value groups (data-group="x") — toggle is-active on the
    // button whose data-value matches state[x].
    root.querySelectorAll('[data-group]').forEach((groupEl) => {
      const key = groupEl.dataset.group;
      const val = state[key];
      if (val === undefined || val === null) return;
      groupEl.querySelectorAll('button').forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.value === String(val));
      });
    });

       // Multi-value groups (data-multi-group="x") — toggle is-active on
    // every button whose data-value is in state[x].
    root.querySelectorAll('[data-multi-group]').forEach((groupEl) => {
      const key = groupEl.dataset.multiGroup;
      const vals = Array.isArray(state[key]) ? state[key] : [];

      groupEl.querySelectorAll('button').forEach((btn) => {
        btn.classList.toggle('is-active', vals.includes(btn.dataset.value));
      });

      if (typeof updateMultiDropdownLabel === 'function') {
        updateMultiDropdownLabel(groupEl);
      }
    });

    if (fitzpatrickEl && state.fitzpatrick) {
  fitzpatrickEl.value = String(state.fitzpatrick);
}

if (state.routine_preference) {
  root.dataset.routinePreference = state.routine_preference;
}
  }

  function applyPersistedState(persisted) {
    if (!persisted) return;

    // Apply paediatric mode FIRST if needed, because applyPaediatricMode
    // would otherwise clobber the persisted state with paediatric defaults.
    if (persisted.state && persisted.state.age === '0-12') {
      applyPaediatricMode(true);
    }

    // Overlay persisted values on top of whatever the init flow set.
    if (persisted.state && typeof persisted.state === 'object') {
      STATE_KEYS_TO_PERSIST.forEach((key) => {
        const val = persisted.state[key];
        if (val !== undefined && val !== null) {
          state[key] = val;
        }
      });
    }

   if (Array.isArray(persisted.removedSlots)) {
  removedSlots = new Set(persisted.removedSlots);
}
if (state.age === '45+' || state.age === '45-54' || state.age === '55+') {
  state.age = '45-59';
}

if (state.age === '0-12') {
  state.concern = '';
  state.routine_preference = 'am_plus_pm';
  state.include_makeup = 'no';
  state.recent_isotretinoin = 'no';
  state.topical_steroid_use = 'no';
  state.current_actives = [];
  state.treatments = [];
  state.skin_sensitivity = normalizeValue(DEFAULTS.skin_sensitivity);

  if (state.budget === 'over_2000') {
    state.budget = '700_2000';
  }
}
if (state.age === '13-17') {
  state.include_makeup = 'no';
  applyPaediatricMode(false);
}
syncUIFromState();
  }

  async function addRoutineToCart() {
    if (!currentRecommendations.length || !addToCartBtn) return;

    addToCartBtn.disabled = true;
    if (statusEl) statusEl.textContent = 'Adding routine to cart…';

    try {
     const items = currentRecommendations
  .filter((product) => product.id && product.available)
  .map((product) => ({
    id: product.id,
    quantity: 1
  }));

      if (!items.length) throw new Error('No valid variants found.');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Could not add routine to cart.');

      if (statusEl) statusEl.textContent = 'Routine added to cart.';
      window.location.href = '/cart';
    } catch (error) {
      console.error('[BuildMyRoutine] add to cart failed:', error);
      if (statusEl) statusEl.textContent = 'Sorry, we could not add this routine to cart.';
      addToCartBtn.disabled = false;
    }
  }

  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (!disclaimerAccepted) {
        openDisclaimer();
        return;
      }

      openDrawer();
    });
  });

  // Click-to-close: any click that lands OUTSIDE the panel closes the
  // drawer (this covers the dimmed overlay area and is robust even if
  // the data-build-routine-close attribute on the overlay ever got
  // stripped). Clicks INSIDE the panel only close when the click hits
  // an element explicitly marked data-build-routine-close (the X
  // button). This is event-delegated on root, so it fires regardless of
  // whether sibling layers swallow events.
  root.addEventListener('click', (event) => {
    if (!root.classList.contains('is-open')) return;
    const inPanel = event.target.closest('.build-my-routine-panel');
    if (!inPanel) {
      // Click on overlay (or anywhere outside the panel) closes.
      closeDrawer();
      return;
    }
    if (event.target.closest('[data-build-routine-close]')) {
      // Click on the X button (or anything else explicitly marked close).
      closeDrawer();
    }
  });

  // Wheel-to-scroll over the overlay: while the drawer is open, the
  // page body is locked (overflow:hidden), so wheel events outside the
  // panel would otherwise do nothing. Forward deltaY from the overlay
  // into whichever element is the active scroll container at the
  // current viewport size (the panel on mobile, the body grid on
  // desktop). Bound on root, not overlay, so it still works if the
  // overlay element ever fails to receive events directly.
  root.addEventListener('wheel', (event) => {
    if (!root.classList.contains('is-open')) return;
    if (event.target.closest('.build-my-routine-panel')) return;
    const isDesktop = window.matchMedia('(min-width: 991px)').matches;
    const scrollTarget = isDesktop
      ? root.querySelector('.build-my-routine-body')
      : panel;
    if (scrollTarget) {
      scrollTarget.scrollTop += event.deltaY;
      event.preventDefault();
    }
  }, { passive: false });

  if (disclaimerCancelBtn) {
  disclaimerCancelBtn.addEventListener('click', closeDisclaimer);
}

if (disclaimerRoot) {
  disclaimerRoot.addEventListener('click', (event) => {
    if (event.target.closest('.build-my-routine-disclaimer__dialog')) return;

    closeDisclaimer();
  });
}
  if (disclaimerConfirmBtn) {
    disclaimerConfirmBtn.addEventListener('click', () => {
      disclaimerAccepted = true;
      closeDisclaimer();
      openDrawer();
    });
  }

  if (shuffleBtnEl) {
    shuffleBtnEl.addEventListener('click', (event) => {
  if (shuffleBtnEl.getAttribute('aria-disabled') === 'true') {
    event.preventDefault();

    shuffleBtnEl.classList.add('is-tooltip-visible');
    clearTimeout(shuffleBtnEl._tooltipTimer);
    shuffleBtnEl._tooltipTimer = setTimeout(() => {
      shuffleBtnEl.classList.remove('is-tooltip-visible');
    }, 2500);

    return;
  }

  shuffleRoutine();
});
  }

 if (addToCartBtn) {
  addToCartBtn.addEventListener('click', addRoutineToCart);
}

  if (noResultsClearBrandsBtn) {
    noResultsClearBrandsBtn.addEventListener('click', clearBrandFilter);
  }

  if (fitzpatrickEl) {
    fitzpatrickEl.addEventListener('change', () => {
      state.fitzpatrick = fitzpatrickEl.value;
      updateRecommendations();
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDisclaimer();
      closeDrawer();
    }
  });

initializeStaticGroups();
initializeDynamicGroups();

// Load any previously saved state (filters + removed slots) for this
// customer (or the anonymous bucket) and apply it on top of the
// freshly-initialised defaults. This must run BEFORE the first
// updateRecommendations() so the initial render reflects the user's
// last session.
applyPersistedState(loadPersistedState());

updateRecommendations();

window.__bmrReady = true;

if (window.__bmrRequestedOpen) {
  window.__bmrRequestedOpen = false;
  if (openButtons[0]) openButtons[0].click();
}
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBuildMyRoutine);
} else {
  initBuildMyRoutine();
}
